import {
  Archive01Icon,
  Bookmark02Icon,
  Clock01Icon,
  Radio02Icon
} from '@hugeicons/react'

import type { FilterChipOption } from '@/shared/ui/Layout/page/FilterChips'

import {
  SCHEDULE_TIME_FILTER_PRIORITY,
  type ScheduleTimeFilter
} from '../model/types'

export const SCHEDULE_TIME_FILTERS: { id: ScheduleTimeFilter; labelKey: string }[] =
  SCHEDULE_TIME_FILTER_PRIORITY.map(id => {
    const labelKeyById: Record<ScheduleTimeFilter, string> = {
      agora: 'schedule.filters.live',
      proximas: 'schedule.filters.next',
      'meu-checkin': 'schedule.filters.myCheckIn',
      passadas: 'schedule.filters.past'
    }
    return { id, labelKey: labelKeyById[id] }
  })

const SCHEDULE_TIME_FILTER_ICONS: Partial<
  Record<ScheduleTimeFilter, FilterChipOption<ScheduleTimeFilter>['icon']>
> = {
  agora: <Radio02Icon size={12} variant="stroke" aria-hidden />,
  proximas: <Clock01Icon size={12} variant="stroke" aria-hidden />,
  passadas: <Archive01Icon size={12} variant="stroke" aria-hidden />,
  'meu-checkin': <Bookmark02Icon size={12} variant="stroke" aria-hidden />
}

export const buildScheduleTimeFilterOptions = (
  t: (key: string) => string
): FilterChipOption<ScheduleTimeFilter>[] =>
  SCHEDULE_TIME_FILTERS.map(filter => ({
    id: filter.id,
    label: t(filter.labelKey),
    icon: SCHEDULE_TIME_FILTER_ICONS[filter.id]
  }))
